import _get from 'lodash/get';
import _castArray from 'lodash/castArray';

import { Base, Address } from '@/models';
import { toCamelCase, omitDeep } from '@/utilities';
export class Customer extends Base {

  public id: string;
  public companyName: string;
  public contactName: string;
  public branchName: string;
  public address: Address;
  

  /**
   * Constructor initialises the variables from the class Customer
   * @param data - the data to construct a type with all properties of <Customer>
   */
  public constructor(data?: Partial<Customer>) {
    super(data);
    data = toCamelCase(data);

    this.id = _get(data, 'id', '');
    this.companyName = _get(data, 'companyName', '');
    this.contactName = _get(data, 'contactName', '');
    this.branchName = _get(data, 'branchName', '');
		this.address = new Address(_get(data, 'address'));
  }

  /**
   * Convert class instance back into a plain old JSON object
   * and recursively remove all uuids we've add for Vue.
   *
   * @return {Object}
   */
  public toObject() {
    return omitDeep({ ...this }, ['_uuid']);
  }

}
